import styles from './../../pages/product.module.css';
import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';
import { mapRFQStatus } from '../../utils/mapRFQStatus';
import { convertEntitiesDeep } from '../../utils/convertEntities';

const RFQDetails = ({ rfq, showQueriesButton = false }) => {
  const [confirmDelete, toggleConfirmDelete] = useState(false); //Loading isloading toggle
  const [status, setStatus] = useState(rfq.status);
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.user);

  // Delete rfq  handler ------------------------------------------------>>

  const deleteQuote = async () => {
    axios
      .delete(`${process.env.REACT_APP_API}/admin/quantila/rfq/${rfq.id}`, {
        headers: { authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.status === 204) {
          toast.success(
            'Request for quotation was successfully deleted from the database.',
            {
              duration: 3000,
            },
          );
          setTimeout(() => {
            navigate('/quantila/rfqs');
          }, 2000);
        }
      })
      .catch((err) => {
        toast.error(err.message, {
          duration: 3000,
        });
      });
  };

  const updateStatus = async () => {
    axios
      .put(
        `${process.env.REACT_APP_API}/admin/quantila/rfq/${rfq.id}`,
        { status },
        {
          headers: { authorization: `Bearer ${token}` },
        },
      )
      .then((response) => {
        if ((response.status = 200)) {
          toast.success(convertEntitiesDeep(response?.data?.message), {
            duration: 3000,
          });
        }
      })
      .catch((err) => {
        toast.error(err.message, {
          duration: 3000,
        });
      });
  };

  //Delete confirmation button toggle handler
  const toggleDelete = () => {
    toggleConfirmDelete((state) => !state);
  };

  return (
    <>
      <div className='product-block col-md-6'>
        <h4 className='h5 mb-3'>{`RFQ TITLE: ${rfq.title}`}</h4>
        <h5 className='h5'>{`RFQ ID: ${rfq.id}`}</h5>

        <div className=''>
          {status > 0 && (
            <>
              <button
                className={`${styles.edit} ${styles.btn}`}
                onClick={updateStatus}
              >
                {`UPDATE STATUS  `}
                <FontAwesomeIcon icon='pen-square' />
              </button>
              <label htmlFor='processId' className='form-label my-3 mx-1'>
                status
              </label>
              <select
                value={status}
                onChange={(evt) => setStatus(evt.target.value)}
                id='processId'
                name='processId'
                className={`form-select form-control d-inline ${styles.pid}`}
              >
                <option className='default-select' value='1'>
                  1
                </option>
                <option className='default-select' value='2'>
                  2
                </option>
                <option className='default-select' value='3'>
                  3
                </option>
                <option className='default-select' value='4'>
                  4
                </option>
                <option className='default-select' value='5'>
                  5
                </option>
                <option className='default-select' value='6'>
                  6
                </option>
                <option className='default-select' value='7'>
                  7
                </option>
                <option className='default-select' value='8'>
                  8
                </option>
              </select>
            </>
          )}

          <div className={styles.actions}>
            {showQueriesButton && (
              <button
                className={`${styles.list} ${styles.btn}`}
                onClick={() => navigate(`/quantila/rfq/queries/${rfq.id}`)}
              >
                SENT QUERIES <FontAwesomeIcon icon='paper-plane' />
              </button>
            )}

            {confirmDelete ? (
              <button
                className={`${styles.del} ${styles.btn}`}
                onClick={deleteQuote}
              >
                {`DELETE ANYWAY??  `}
                <FontAwesomeIcon icon='trash' />
              </button>
            ) : (
              <button
                className={`${styles.del} ${styles.btn}`}
                onClick={toggleDelete}
              >
                {status < 1 ? 'DELETE RFQ DRAFT  ' : 'DELETE RFQ  '}
                <FontAwesomeIcon icon='trash' />
              </button>
            )}
          </div>
        </div>

        <p className='product-subheads product-type mb-2 mt-3'>
          <span className={styles.label}>End User:</span>
          <span className={styles.value}>{rfq.enduser}</span>
        </p>
        <p className='product-subheads product-brand mb-2'>
          <span className={styles.label}>Incoterm:</span>
          <span className={styles.value}>{rfq.incoterm}</span>
        </p>
        <p className='product-subheads product-brand mb-2'>
          <span className={styles.label}>Required Certification:</span>
          <span className={styles.value}>{rfq.requiredCert}</span>
        </p>
        <p className='product-subheads product-brand mb-2'>
          <span className={styles.label}>Destination City:</span>
          <span className={styles.value}>{rfq.destinationCity}</span>
        </p>
        <p className='product-subheads product-brand mb-2'>
          <span className={styles.label}>Destination Country:</span>
          <span className={styles.value}>{rfq.destinationCountry}</span>
        </p>
        <p className='product-subheads product-type mb-2'>
          <span className={styles.label}>Required By:</span>
          <span className={styles.value}>
            {new Date(rfq.requiredBy).toLocaleString('en-UK', {
              dateStyle: 'long',
              timeStyle: 'short',
            })}
          </span>
        </p>
        <p className='product-subheads product-type mb-2'>
          <span className={styles.label}>Requested on:</span>
          <span className={styles.value}>
            {new Date(rfq.createdAt).toLocaleString('en-UK', {
              dateStyle: 'long',
              timeStyle: 'short',
            })}
          </span>
        </p>
        <p className='product-subheads product-condition mb-2'>
          <span className={styles.label}>Notes:</span>
        </p>
        <pre className='product-subheads product-condition mb-2'>
          {rfq.notes}
        </pre>
      </div>
    </>
  );
};

export default RFQDetails;
